<template>
  <div class="mt-3" ref="businessOwnership">
    <v-card>
      <v-card-title>
        <span>{{ $t('title.application_business_ownership') }}</span>
      </v-card-title>
      <v-card-text class="p-n">
        <div class="mb-3 mt-1">
          <el-checkbox v-model="notApplicable" @change="checkApplicable()">{{ $t('global.not_applicable') }}</el-checkbox>
        </div>
        <v-alert type="info" border="left" dense class="mb-3" v-if="$t('infobox.application_business_ownership') !== ''">
           {{ $t('infobox.application_business_ownership') }}
        </v-alert>
        <table class="table" style="width:100%">
          <thead>
            <tr>
              <th width="80">{{ $t('application_business_ownership.year') }}</th>
              <th>{{ $t('application_business_ownership.bussinessname') }}</th>
              <th>{{ $t('application_business_ownership.type') }}</th>
              <th>{{ $t('application_business_ownership.percentage') }}</th>
              <th>{{ $t('application_business_ownership.co_owners') }}</th>
              <th width="30">
                <v-btn :disabled="notApplicable" color="green" small fab @click.native="addForm()">
                  <v-icon class="white--text">add</v-icon>
                </v-btn>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in items" :key="i" :id="'row' + item.id">
              <td class="pa-1">
                <el-input :disabled="notApplicable" :id="'year' + item.id" :maxlength="4" v-model="item.year" style="width: 100%" />
              </td>
              <td class="pa-1">
                <el-input :disabled="notApplicable" :id="'bussinessname' + item.id" v-model="item.bussinessname" style="width: 100%" />
              </td>
              <td class="pa-1">
                <el-input :disabled="notApplicable" :id="'type' + item.id" v-model="item.type" style="width: 100%" />
              </td>
              <td class="pa-1">
                <el-input :disabled="notApplicable" :id="'percentage' + item.id" v-model="item.percentage" style="width: 100%" />
              </td>
              <td class="pa-1">
                <el-input :disabled="notApplicable" :id="'co_owners' + item.id" v-model="item.co_owners" style="width: 100%" />
              </td>
              <td class="pa-1 text-center">
                <v-btn :disabled="notApplicable" color="pink" small fab @click.native="deleteOpen(item, i)"><v-icon class="white--text">clear</v-icon></v-btn>
              </td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer />
        <v-btn :loading="loading" :disabled="loading || notApplicable" color="primary" small @click.native="submitForm()">
          {{ $t('global.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import datavalidation from '@/mixins/datavalidation.js'

export default {
  props: {
    sectionId: {
      type: String
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    },
    datas: {
      type: Array
    }
  },
  mixins: [datavalidation],
  data() {
    return {
      form: {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        bussinessname: null,
        co_owners: null,
        percentage: null,
        type: null,
        year: null,
        sec_org_id: this.$orgId
      },
      state: 'businessOwnership',
      url: 'imms_table/application_business_ownership',
      loading: false
    }
  },
  watch: {
    memberUID: function() {
      this.fetchData()
    }
  },
  computed: {
    ...mapGetters({
      applicableId: 'applicable/id'
    }),
    items: {
      get() {
        return this.$store.state.all_stores[this.state]
      }
    },
    notApplicable: {
      get() {
        return this.$store.state.applicable.notApplicable.business_ownership
      },
      set(val) {
        this.$store.commit('applicable/set_business_ownership', val)
      }
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    checkDate: function(event) {
      this.$emit('checkDate', event)
    },
    fetchData() {
      this.$Progress.start()
      var url = 'table/application_business_ownership?filter=member_uid=' + this.memberUID
      this.$store.dispatch('all_stores/getAll', { 'url': url, 'slug': this.state })
        .then(response => {
          if (this.datas !== undefined) {
            this.checkTableFields(this.items, this.datas, this.sectionId)

            if (this.notApplicable) {
              $(this.$refs.businessOwnership).remove()
            }
          }
          this.$Progress.finish()
        })
        .catch(err => {
          this.$Progress.fail()
        })
    },
    nodeClear() {
      this.form = {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        bussinessname: null,
        co_owners: null,
        percentage: null,
        type: null,
        year: null,
        sec_org_id: this.$orgId
      }
    },
    addForm() {
      this.nodeClear()
      this.items.push(this.form)
    },
    submitForm() {
      if (this.items.length > 0) {
        this.loading = true
        this.items.forEach(function(item) {
          var action = 'all_stores/save'
          if (item.id != undefined) {
            action = 'all_stores/edit'
            item.id = parseFloat(item.id)
          }
          this.$Progress.start()
          this.$store.dispatch(action, { 'url': this.url, 'data': item, 'slug': this.state })
            .then(response => {
              if (response.data.resource && response.data.resource.length > 0) {
                item.id = response.data.resource[0].id
                item.imms_uuid = response.data.resource[0].imms_uuid
              }
              this.$store.dispatch('toaster/add', { text: 'Save', type: 'success' })
              this.$Progress.finish()
              this.loading = false
            })
            .catch(err => {
              this.$store.dispatch('toaster/add', { text: 'Error', type: 'success' })
              this.$Progress.fail()
              this.loading = false
            })
        }, this)
      }
      else {
        return false
      }
    },
    resetForm() {
      this.$refs.item.resetFields()
      this.nodeClear()
    },
    checkApplicable() {
      var action = 'applicable/save'
      var that = this
      var data = {}
      data.business_ownership = that.notApplicable
      data.application_id = this.$route.params.id
      data.member_id = parseFloat(this.memberID)
      data.member_uid = this.memberUID
      if (that.applicableId != undefined) {
        data.id = that.applicableId
        action = 'applicable/edit'
      }
      this.$Progress.start()
      this.$store.dispatch(action, data).then(response => {
        this.$store.dispatch('toaster/add', { text: 'Updated', type: 'success' })
        this.$Progress.finish()
      })
        .catch(err => {
          this.$store.dispatch('toaster/add', { text: 'Updated', type: 'success' })
          this.$Progress.fail()
        })
    }
  }
}
</script>
